import { Link } from "react-router-dom";
import ReactPlayer from "react-player";

import { Spacer, boxContainer, Buttons } from "../../components";

function Recommenders() {
  return (
    <div className="text-black">
      <boxContainer.LiteBoxContainer>
        <div className="header-md text-main">
          Are You Facing Difficulties Choosing Universities?
        </div>
        <Spacer height={20} />
        <div className="header-sm">
          Use our proprietary Recommender feature to help you find the best
          university based on your requirements. Take a peek at the video below
          to see how it works!
        </div>
        <Spacer height={40} />
        <div className="flex flex-col justify-center items-center gap-4">
          <ReactPlayer
            url={"https://youtu.be/lrjixk6fmbQ?si=SDDIGUPBnJBRvZep"}
            height="31.25em"
            width="55.5em"
            controls={true}
          />
          <div className="header-sm">Click The Button Below To Start Now.</div>
          <Link to="/recommender/qualifications" className="w-[12.5em]">
            <Buttons.DefaultButton width="full">Start</Buttons.DefaultButton>
          </Link>
        </div>
      </boxContainer.LiteBoxContainer>
    </div>
  );
}

export default Recommenders;
